import {React, useState} from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import ArticlePage from "./components/ArticlePage";
import "./App.css";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:articleSlug" element={<ArticlePage />} />
      </Routes>
    </Router>
  );
};

export default App;
